import { createEvent, createStore } from 'effector';
import type { ViewMode } from '../types';

export const setViewMode = createEvent<ViewMode>();
export const toggleViewMode = createEvent();

export const $viewMode = createStore<ViewMode>('orbit')
  .on(setViewMode, (_, mode) => mode)
  .on(toggleViewMode, (mode) => (mode === 'first-person' ? 'orbit' : 'first-person'));
